import React from "react";
import { adminTheme } from "styles/adminTheme";

export default function RoleChip({ label, tone = "default" }) {
    const tones = {
        default: {
            bg: "rgba(15,23,42,0.08)",
            color: "#0f172a",
            border: "rgba(15,23,42,0.12)",
        },
        admin: {
            bg: "rgba(6,182,212,0.15)",
            color: "#0891b2",
            border: "rgba(6,182,212,0.35)",
        },
        danger: {
            bg: "rgba(220,38,38,0.12)",
            color: "#dc2626",
            border: "rgba(220,38,38,0.35)",
        },
    };

    const t = tones[tone] || tones.default;

    return (
        <span
            title={label}
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: t.bg,
                color: t.color,
                border: `1px solid ${t.border}`,
                padding: "4px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                marginRight: 6,
                marginBottom: 6,
                whiteSpace: "nowrap",
                lineHeight: 1.2,
            }}
        >
            {label}
        </span>
    );
}
